<h4 *ngIf="enableTitle">{{ 'shared:rmm.groupActions.stepConfigureAction.installSoftTitle' | i18next: { format: 'title' }
  }}</h4>

<mbs-alert [type]="alertType.info"
           [icon]="true"
           class="mb-2">
  {{ 'shared:rmm.groupActions.stepConfigureAction.installSoftBanner' | i18next }}
</mbs-alert>

<mbs-form-group [formGroup]="installForm">
  <div class="mb-3">

    <div>
      <mbs-input-label [label]="installLabel"
                       [boldLabel]="true">
      </mbs-input-label>


      <ng-template #installLabel>
        {{ 'shared:rmm.groupActions.stepConfigureAction.downloadLink' | i18next }}
        <span class="ml-1 text-info ico ico-InfoCircle"
              [ngbTooltip]="installLinkTooltip"
              container="body"
              tooltipClass="tooltip-lg">
        </span>
      </ng-template>

      <ng-template #installLinkTooltip>
        <div class="text-start">
          <ul class="m-2 p-2">
            <li>{{ 'shared:rmm.groupActions.stepConfigureAction.downloadLinkTooltip1' | i18next }}</li>
            <li>{{ 'shared:rmm.groupActions.stepConfigureAction.downloadLinkTooltip2' | i18next }}</li>
            <li>{{ 'shared:rmm.groupActions.stepConfigureAction.downloadLinkTooltip3' | i18next }}</li>
          </ul>
          <div>{{ 'shared:rmm.groupActions.stepConfigureAction.downloadLinkTooltip4' | i18next }}</div>
        </div>
      </ng-template>
    </div>

    <mbs-input [autocomplete]="'off'"
               [class]="'text-base'"
               [placeholder]="'shared:rmm.groupActions.stepConfigureAction.downloadLinkPlaceholder' | i18next"
               formControlName="url">
    </mbs-input>
  </div>


  <div>
    <div>
      <mbs-input-label [label]="'shared:rmm.groupActions.stepConfigureAction.installKeys' | i18next"
                       [boldLabel]="true">
      </mbs-input-label>
      <div class="text-sm">
        {{ 'shared:rmm-side-panel.softwareTab.installUrlDescription' | i18next }}
      </div>
    </div>

    <mbs-input [autocomplete]="'off'"
               [class]="'text-base'"
               [placeholder]="'/S'"
               formControlName="arguments">
    </mbs-input>
  </div>

</mbs-form-group>
